import React from "react";
import { motion } from "framer-motion";
import { content } from "../lib/i18n";
import { useLang } from "../context/LanguageContext";

const ABOUT_IMG = `${process.env.PUBLIC_URL || ""}/brand/cat-tacos.jpg`;

const About = () => {
  const { lang } = useLang();
  const data = lang === "en" ? content.about.en : content.about.fr;

  return (
    <section id="about" data-testid="about-section" className="bg-white section">
      <div className="mx-auto max-w-[1320px] px-5 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Image */}
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            className="lg:col-span-5 order-2 lg:order-1"
          >
            <div className="bb-img-zoom h-[300px] sm:h-[380px] lg:h-[460px] border-[3px] border-black rounded-[24px]">
              <img src={ABOUT_IMG} alt="Big Boss Snack Bar — tacos" loading="lazy" />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="lg:col-span-7 order-1 lg:order-2"
          >
            <span className="eyebrow-yellow">
              <span>★</span>
              <span>{data.eyebrow}</span>
            </span>

            <h2
              data-testid="about-title"
              className="mt-5 h-display text-black text-[36px] sm:text-[48px] md:text-[60px] lg:text-[72px] leading-[0.95]"
            >
              <span className="block">{data.title}</span>
              <span className="block">
                <span className="inline-block italic mt-1" style={{
                  background: "linear-gradient(transparent 60%, var(--bb-yellow) 60%)",
                  padding: "0 0.15em",
                }}>
                  {data.titleAccent}
                </span>
              </span>
            </h2>

            <p
              className="mt-6 text-base md:text-lg text-black/75 leading-relaxed max-w-2xl"
              data-testid="about-p1"
            >
              {data.p1}
            </p>
            <p
              className="mt-4 text-base md:text-lg text-black/75 leading-relaxed max-w-2xl"
              data-testid="about-p2"
            >
              {data.p2}
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
